export default __webpack_public_path__ + "static/ee-web-logo-e5a172f095948c8150c5c1c49baded66.svg";